<template>
	<div>
		<SearchBar 
			:class="$vuetify.breakpoint.xs ? 'mx-0' :'mx-5'" 
			:saveAs="!show_worklists"
			:close_show="show_worklists"
			:key="search_bar_key"  
			@search="onSearch"
			@save-worklist="onShowSaveDialog" />
		<v-alert class="mx-5" type="error" v-if="errormsg.length !== 0">
			{{ errormsg }}
		</v-alert>
		<div class="mx-6 my-3 back" v-if="!loading && !show_worklists" @click="onBack()">&lt; Back to Saved Worklists</div>
		<ProgressLinear v-if="loading" />
		<div :class="$vuetify.breakpoint.xs ? 'px-0': 'px-5'" v-if="!loading && errormsg.length === 0 && show_worklists">
			<ControlBar
				class="px-5"
				v-if="errormsg.length === 0" 
				:include_shared="include_shared"
				:include_hidden="include_hidden"
				@include_shared_checkbox="include_shared = $event"
				@include_hidden_checkbox="include_hidden = $event"/>
			<WorklistItem 
				v-for="worklist in worklists"
				:key="`worklistItem_${worklist.id}`"
				:worklist="worklist"
				:mini="$attrs.mini"
				@click="onSelect"
				@hide-changed="onHideChanged"
				@rename="rename_worklist"
				@delete="delete_worklist"
				@err-msg="onErrMsg"/>
		</div>
		<div :class="`results ${$vuetify.breakpoint.xs ? 'px-0': 'px-5'}`" v-if="!loading && errormsg.length === 0 && !show_worklists" >
			<SearchColsFilter 
				v-if="show_cols_filter" 
				:class="$vuetify.breakpoint.smAndDown ?'search-result-single' : 'search-filter' " 
				:selected="selected"
				:financialsPrivilege="financialsPrivilege"
				@close="onCloseSearchColsFilter"/>
			<SearchResults
				v-if="show_search_result"
				:class="show_cols_filter ? 'search-result-multi': 'search-result-single'"
				:joblists="joblists" 
				:headers="head_kv"
				:color="$attrs.color"
				:page="1"
				:perpage="limit"
				@columns="onShoworHideColsFilter()"/>
		</div>
		<DelWorklistDialog
			ref="del_worklist_dialog"
			@deleted="load_worklists()"
		/>
		<RenameWorklistDialog
			ref="rename_worklist_dialog"
			@renamed="load_worklists()"
		/>
		<NewWorklistDialog 
			:visible="show_saveDialog" 
			:is_saved="is_saved"
			@saved="onSaveAsWorklist"
			@cancel="show_saveDialog = false"/>
	</div>
</template>

<script>

import SearchBar from '@/components/jobs/search_bar.vue';
import ControlBar from '@/components/worklist/worklist_control_bar';
import WorklistItem from "@/components/worklist/worklist_item_new";
import SearchResults from "@/components/jobs/search_results_new";
import SearchColsFilter from '@/components/jobs/search_cols_filter';
import ProgressLinear from "@/components/progress/progress_getdata_linear";
import DelWorklistDialog from "@/components/worklist/del_worklist_dialog";
import RenameWorklistDialog from "@/components/worklist/rename_worklist_dialog";
import NewWorklistDialog from "@/components/worklist/new_worklist_dialog_new";

import Worklist from "@/models/worklist.js";
import config from "@/config.js";

const WORKLIST_CLASS = 'restful.jobs.worklists';
const wl = new Worklist();

/** If selected the user will be able to access the Financial tab in the Jobs window */
const JOf = 'JOf';
const Financials_Group = ['total_value', 'perc_quoted_billed', 'total_invoiced', 'perc_value_billed', 'perc_traffic_used'];

export default {
	name: 'SavedWorklist',
	data() {
		return {
			errormsg: '',
			loading: false,
			show_worklists: true,
			include_shared: true,
			include_hidden: false,
			worklists: [],
			settings: null,
			search_status: [],
			joblists: [],
			head_kv: [],
			financialsPrivilege: true,
			show_cols_filter: false,
			show_search_result: true,
			search_bar_key: 0,
			show_saveDialog: false,
			is_saved: false,

			tid: null,
			tid0: null,
			limit: this.$vuetify.breakpoint.smAndDown ? 10 : config.countPerpage,
		}
	},
	components: {
		SearchBar,
		ControlBar,
		WorklistItem,
		SearchResults,
		SearchColsFilter,
		ProgressLinear,
		DelWorklistDialog,
		RenameWorklistDialog,
		NewWorklistDialog
	},
	async created() {
		/* add this page to our breadcrumbs */
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Saved Worklists",
			to: this.$route.path
		});
		
		this.load_worklists();
		await this.getFinancialsPrivilege();

		if (this.financialsPrivilege) {
			this.head_kv = config.head_kv;
		} else {
			const head_tmp = JSON.parse(JSON.stringify(config.head_kv));
			head_tmp.forEach(h => {
				if (Financials_Group.includes(h.value)) {
					h.showable = false;
				}
			});
			this.head_kv = head_tmp;
		}

	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
		if(this.tid0) {
			clearTimeout(this.tid0);
		}
	},
	watch: {
		include_shared() {
			this.load_worklists();
		},
		include_hidden() {
			this.load_worklists();
		}
	},
	computed: {
		selected() {
			const arr = [];
			this.head_kv.forEach(item => {
				if (item.showable) {
					const obj = {
						text: item.text,
						value: item.value,
					}
					arr.push(obj);
				}
			});
			return arr;
		},
	},
	methods: {
		load_worklists() {
			this.loading = true;

			wl.list(WORKLIST_CLASS, this.include_shared, this.include_hidden)
				.then(d => {
					this.loading = false;
					d.sort((a,b) => { return a.id - b.id });
					this.worklists = d;
				})
				.catch(message => {
					this.errormsg = message;
				})
				.finally(() => {
					this.loading = false;
				});	
		},
		async getFinancialsPrivilege() {
			const url = "/api/user/me/privileges";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					const {status, data}  = val.data;

					if (status === "OK") {
						if (data.includes(JOf)) {
							this.financialsPrivilege = true;
						} else {
							this.financialsPrivilege = false;
						}
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		onSelect(wlid) {
			this.$router.push({ name: "Job Worklist", params: { id:  wlid }})			
		},
		onErrMsg(msg) {
			if (msg) {
				this.errormsg = msg;
			}
		},
		onHideChanged() {
			if(!this.include_hidden) {
				this.load_worklists();
			}
		},
		onBack() {
			this.loading = false;
			this.errormsg = '';
			this.show_worklists = true;
			this.joblists = [];
			this.search_bar_key += 1;
			this.show_cols_filter = false;
			this.load_worklists();
		},
		delete_worklist(worklist_id) {
			wl.load(worklist_id).then(() => {
				this.$refs.del_worklist_dialog.open(wl);
			}).catch(e => {
				console.log(e)
			})
		},
		rename_worklist(worklist) {
			this.$refs.rename_worklist_dialog.open(worklist);
		},
		onShowSaveDialog() {
			this.show_saveDialog = true;
		},
		onSaveAsWorklist(params) {
			const search = {
				short: this.settings.short && this.settings.short.length !== 0 ? this.settings.short : "",
				statusses: this.settings.statusses && this.settings.statusses.length !== 0 ? this.settings.statusses : [],
			}	

			wl.id = 0;
			wl.class = WORKLIST_CLASS;
			wl.name = params.name;
			wl.is_dynamic = params.is_dynamic;
			wl.is_owned = true;
			wl.settings = search;
			
			wl.create()
				.then(() => {
					this.is_saved = true;
					this.tid = setTimeout(this._close, 2000);
					this.tid0 = setTimeout(this._setInit, 2500);
				})
				.catch(function(reason) {
					this.errormsg = reason;
					this._close();
				});
		},
		onShoworHideColsFilter() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.show_cols_filter = true;
				this.show_search_result = false;
			} else {
				this.show_cols_filter = !this.show_cols_filter;
			}
		},
		onCloseSearchColsFilter(event) {
			if (event) {
				const event_arr = event.map(items => { return items.text});
				const obj = JSON.parse(JSON.stringify(config.head_kv));

				obj.forEach(head => {
					if (event_arr.includes(head['text'])) {
						head['showable'] = true;
					} else {
						head['showable'] = false;
					}
				})
				this.head_kv = obj;
			}

			this.show_cols_filter = false;
			this.show_search_result = true;
		},
		async onSearch(event) {
			if (!event) return;

			const params = [];
			if (event.key === 'short') {
				params.push(`${event.key}=${encodeURIComponent(event.value)}`);
				this.settings = { short: event.value }
			}
			if (event.key === 'statusses') {
				await this._status_query(event.value);
					
				if (this.search_status.length !== 0) {
					params.push(`${event.key}=${encodeURIComponent(this.search_status)}`);
					this.settings = { statusses: this.search_status };
				} else {
					params.push(`${event.key}=${encodeURIComponent(0)}`);
				}
			}
			params.push('is_lookup' + '=' + encodeURIComponent(false));


			this.show_worklists = false;
			this._search(params);
		},
		_search(params) {
			this.loading = true;
			
			let url = "/api/jobs";
			if (params.length > 0) {
				url += "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const json = val.data;

					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data,  reason} = json;

					if (status === "OK") {
						this.joblists = data;
						this.loading = false;
					} else {
						this.errormsg = reason;
					}
				})
				.catch(e => {
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});	

		},
		async _status_query(v) {
			await axios
				.get("/api/jobs/meta", {
				})
				.then(val =>  {
					const json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data, reason } = json;

					if (status == "OK") {
						const statusses = data.substatusses;
						const status_all = statusses.filter(status => {
							const A = status.desc.toUpperCase();
							return A.includes(v.toUpperCase());
						});

						this.search_status = status_all.map(status => {return status.id} );

					} else {
						this.errormsg = reason;
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});  
		},
		async _client_query(v) {
			const types = '1,14'; // 1=client, 14=prospects
			const params = [];
			params.push("name=" + encodeURIComponent(v));
			params.push("abook_types=" + encodeURIComponent(types));

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.client_res = data.map(d => {return d.id} );						
					} 
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		_close() {
			this.show_saveDialog = false;
			this.onBack();
		},
		_setInit() {
			this.is_saved = false;
		}
	},
}
</script>
<style lang="scss" scoped>
.back {
	color: #2196F3;
	text-decoration: underline;
	font-family: Roboto;
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	&:hover {
		cursor: pointer;
	}
}
.results {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}
.search-result-single {
	width: 100%;
}
.search-filter {
	width: 24%;
}
.search-result-multi {
	width: 75%;
}
.v-tooltip__content {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: white;
	background: #192A3E;
	padding: 7px 8px;
}
.v-input--selection-controls {
	margin-top: 0;
  padding-top: 0;
}
.v-label {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 18px;
	color: #192A3E;
}
</style>
